<div class="fn-card-data" *ngIf="this.cardInfo">
    <div class="fn-card-data__title">
        <span class="fn-card-data__title-text">
            Información de cuenta
        </span>
    </div>
    <div class="fn-card-data__data">
        <div class="fn-card-data__data-field">
            <span class="fn-card-data__data-field-key">
                Nombre de tarjeta
            </span>
            <span class="fn-card-data__data-field-value">
                {{ this.cardInfo.cardName }}
            </span>
        </div>
        <div class="fn-card-data__data-field">
            <span class="fn-card-data__data-field-key">
                Nro. de tarjeta
            </span>
            <span class="fn-card-data__data-field-value">
                {{ this.formatCardNumber(this.cardInfo.cardNumber) }}
                <img
                    *ngIf="!this.hideCardNumber"
                    [src]="
                        this.showCompleteCardNumber ?
                        '../../../../../../assets/icons/eye-slash.svg' :
                        '../../../../../../assets/new-styles/img/eye.png'
                    "
                    alt="Show or hide"
                    class="fn-card-data__data-field-value-showhide"
                    (click)="this.switchShowCompleteCardNumber()"
                >
            </span>
        </div>
        <div class="fn-card-data__data-field">
            <span class="fn-card-data__data-field-key">
                Nro. de cuenta
            </span>
            <span class="fn-card-data__data-field-value">
                {{ this.cardInfo.accountNumber }}
            </span>
        </div>
        <div class="fn-card-data__data-field">
            <span class="fn-card-data__data-field-key">
                Estado
            </span>
            <span class="fn-card-data__data-field-value">
                <!-- TODO: traducir, también -->
                {{ this.cardInfo.cardStatus === 'BLOCKED' ? 'Bloqueada' : 'Activa' }}
            </span>
        </div>
    </div>
</div>
